module.exports = __webpack_public_path__ + "static/media/advantage.0988b398.svg";